<template>
  <Teleport to="body">
    <div v-if="show" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2>Käyttöehdot</h2>
          <button class="close-modal" @click="closeModal" aria-label="Sulje">&times;</button>
        </div>
        
        <div class="modal-body">
          <div class="terms-section">
            <h3>1. Yleistä</h3>
            <p>
              Nämä käyttöehdot koskevat Raviremmi-palvelun käyttöä. Käyttämällä palvelua hyväksyt nämä ehdot kokonaisuudessaan.
            </p>
          </div>

          <div class="terms-section">
            <h3>2. Palvelun Kuvaus</h3>
            <p>
              Raviremmi on virtuaalinen managerointipeli, jossa pelaajat kokoavat oman ravitiiminsä hevosista ja ohjastajasta. 
              Peli perustuu todellisten ravilähtöjen tuloksiin ja on suunniteltu viihdetarkoituksiin.
            </p>
            <p>
              <strong>Tärkeää:</strong> Raviremmi ei ole vedonlyöntiä eikä rahapeliä. Pelissä ei jaeta rahallisia tai materiaalisia palkintoja. 
              Pelirahaa ei voi muuttaa rahaksi eikä pelin lopputuloksesta voi saada rahapalkkiota.
            </p>
          </div>

          <div class="terms-section">
            <h3>3. Premium-tilaus ja Maksaminen</h3>
            <p>
              Premium-version hinta on 3,20€ per jakso. Premium-tilausta koskee kertamaksu, joka erääntyy kahden (2) päivän kuluttua laskun päiväyksestä.
            </p>
            <p>
              <strong>Maksuehdot:</strong>
            </p>
            <ul>
              <li><strong>Aktivointi:</strong> Premium-käyttöoikeus aktivoituu välittömästi tilauksen vahvistamisen jälkeen</li>
              <li><strong>Lasku:</strong> Saat automaattisesti PDF-laskun sähköpostiisi</li>
              <li><strong>Maksuaika:</strong> 2 päivää laskun päivämäärästä</li>
              <li><strong>Viitenumero:</strong> Käytä laskun viitenumeroa maksaessasi - ilman oikeaa viitenumeroa maksu ei kohdistu tilillesi</li>
              <li><strong>Maksamattomuus:</strong> Ellei maksua suoriteta eräpäivään mennessä, Premium-oikeus poistuu automaattisesti. <strong>Emme peri lisäkuluja, viivästyskorkoja tai lähetä muistutuksia.</strong></li>
              <li><strong>Ei seuraamuksia:</strong> Maksamattomuudesta ei aiheudu mitään negatiivisia seuraamuksia tai lisävelvoitteita</li>
              <li><strong>ALV:</strong> Yritys ei ole ALV-rekisterissä, joten laskussa ei ole arvonlisäveroa</li>
            </ul>
            <p>
              Myöhästyneet tai virheelliset maksut eivät oikeuta vahingonkorvaukseen.
            </p>
            <p>
              <strong>Peruuttamisoikeus:</strong> Koska Premium-käyttöoikeus aktivoituu välittömästi ja kyseessä on digitaalinen sisältö, 14 päivän peruuttamisoikeus ei ole voimassa tilauksen vahvistamisen jälkeen.
            </p>
            <p>
              <strong>Peruuttamislomake:</strong> EU:n malliperuuttamislomake on saatavilla 
              <router-link to="/peruuttamislomake" class="terms-link" @click="closeModal">täältä</router-link>, 
              vaikka peruuttamisoikeus menetetään välittömän aktivoinnin vuoksi.
            </p>
          </div>

          <div class="terms-section">
            <h3>4. Käyttäjän Velvollisuudet</h3>
            <p>Käyttäjä sitoutuu:</p>
            <ul>
              <li>Antamaan totuudenmukaisia tietoja rekisteröityessään</li>
              <li>Käyttämään palvelua asianmukaisesti ja laillisesti</li>
              <li>Olemaan häiritsemättä muita käyttäjiä</li>
              <li>Noudattamaan näitä käyttöehtoja</li>
            </ul>
          </div>

          <div class="terms-section">
            <h3>5. Tietosuoja</h3>
            <p>
              Käsittelemme henkilötietojasi huolellisesti ja tietosuojalainsäädännön mukaisesti. 
              Rekisteröitymisen yhteydessä tallennamme sähköpostiosoitteesi ja käyttäjänimesi palvelun toiminnan mahdollistamiseksi.
            </p>
          </div>

          <div class="terms-section">
            <h3>6. Palvelun Saatavuus</h3>
            <p>
              Palvelu tarjotaan "sellaisenaan". Pyrimme 98% vuosi-käyttöaikaan, mutta emme vastaa katkoista, viiveistä tai pistepäivitysten virheistä. Maksuton korvausaika on enintään Premium-jakson pituus; emme korvaa välillisiä vahinkoja.
            </p>
            <p>
              Pidätämme oikeuden keskeyttää palvelun tilapäisesti ylläpitotöiden ajaksi.
            </p>
          </div>

          <div class="terms-section">
            <h3>7. Kilpailutilanteet ja Tulokset</h3>
            <p>
              Tulokset perustuvat virallisiin ravitietoihin. Jos tuloksissa ilmenee virhe, pidätämme oikeuden korjata pisteet 30 päivän kuluessa ilman vastuuvelvoitetta.
            </p>
          </div>

          <div class="terms-section">
            <h3>8. Vastuunrajoitukset</h3>
            <p>
              Palveluntarjoaja ei vastaa epäsuorista vahingoista, ellei vahinko johdu törkeästä huolimattomuudesta tai tahallisuudesta. 
              Palvelu tarjotaan "sellaisenaan" ilman takuita.
            </p>
          </div>

          <div class="terms-section">
            <h3>9. Sopimuksen Päättyminen ja Tilin Sulkeminen</h3>
            <p>
              Voimme irtisanoa tilin tai keskeyttää pääsyn, jos käyttäjä rikkoo ehtoja tai maksua ei suoriteta. Irtisanominen ei oikeuta korvaukseen maksetusta Premium-jaksosta, ellei laki edellytä sitä.
            </p>
          </div>

          <div class="terms-section">
            <h3>10. Ehtojen Muuttaminen</h3>
            <p>
              Pidätämme oikeuden muuttaa näitä käyttöehtoja. Muutoksista ilmoitetaan palvelussa tai sähköpostitse. 
              Jatkamalla palvelun käyttöä hyväksyt muutetut ehdot.
            </p>
          </div>

          <div class="terms-section">
            <h3>11. Sovellettava Laki ja Riidanratkaisu</h3>
            <p>
              Näihin ehtoihin sovelletaan Suomen lakia. Kuluttaja voi viedä asian myös KKV:n kuluttajariitalautakuntaan.
            </p>
          </div>

          <div class="terms-section">
            <h3>12. Yhteystiedot</h3>
            <p>
              Jos sinulla on kysyttävää näistä käyttöehdoista, voit ottaa yhteyttä osoitteeseen: 
              <a href="mailto:info@raviremmi.com" class="contact-link">info@raviremmi.com</a>
            </p>
          </div>

          <div class="terms-footer">
            <p>
              <strong>Viimeksi päivitetty:</strong> 6.7.2025
            </p>
            <p>
              Täydelliset käyttöehdot löydät myös 
              <router-link to="/terms-of-service" class="terms-link" @click="closeModal">erilliseltä sivulta</router-link>.
            </p>
          </div>
        </div>
        
        <div class="modal-actions">
          <button class="btn btn-primary" @click="closeModal">Sulje</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'TermsModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem 1rem;
  overflow-y: auto;
  z-index: 1000;
}

.modal-content {
  background-color: #112240;
  border-radius: 12px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px -15px rgba(2, 12, 27, 0.8);
  border: 1px solid #1e3a5f;
  position: relative;
  margin: 1rem 0;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #1e3a5f;
  position: sticky;
  top: 0;
  background-color: #112240;
  z-index: 1001;
}

.modal-header h2 {
  color: #64ffda;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.close-modal {
  background: none;
  border: none;
  color: #8892b0;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
}

.close-modal:hover {
  color: #64ffda;
}

.modal-body {
  padding: 2rem;
  color: #a8b2d1;
  line-height: 1.6;
}

.terms-section {
  margin-bottom: 1.5rem;
}

.terms-section:last-child {
  margin-bottom: 0;
}

.terms-section h3 {
  color: #e6f1ff;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.terms-section p {
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
}

.terms-section p:last-child {
  margin-bottom: 0;
}

.terms-section ul {
  margin: 0.75rem 0;
  padding-left: 1.5rem;
}

.terms-section li {
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
}

.terms-footer {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #1e3a5f;
  text-align: center;
  font-size: 0.9rem;
}

.terms-link {
  color: #64ffda;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.terms-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.contact-link {
  color: #64ffda;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.modal-actions {
  padding: 1.5rem 2rem;
  border-top: 1px solid #1e3a5f;
  display: flex;
  justify-content: center;
  position: sticky;
  bottom: 0;
  background-color: #112240;
}

.btn {
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  font-weight: 500;
}

.btn-primary {
  background-color: #64ffda;
  color: #0a192f;
  border: none;
}

.btn-primary:hover {
  background-color: #52d6c0;
  transform: translateY(-1px);
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .modal-content {
    margin: 0.5rem 0;
  }
  
  .modal-header,
  .modal-body,
  .modal-actions {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  
  .modal-header h2 {
    font-size: 1.3rem;
  }
}

@media (max-width: 480px) {
  .modal-overlay {
    padding: 1rem 0.5rem;
  }
  
  .modal-header,
  .modal-body,
  .modal-actions {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .terms-section ul {
    padding-left: 1.25rem;
  }
}

/* Custom scrollbar for modal content */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: #1e3a5f;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: #64ffda;
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: #52d6c0;
}
</style>
